module.exports = __webpack_public_path__ + "49f9fa66b09ebc4d201a34c1aee218da.svg";